import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MeteorologyAgroWBSequentialDVState {
  selectedChartVariables: number[];
  group: number | undefined;
  location: number | undefined;
  periodStart: string | undefined;
  periodEnd: string | undefined;
  soil: number | undefined;
  triggerRequest: (() => void) | undefined;
}

const initialState: MeteorologyAgroWBSequentialDVState = {
  selectedChartVariables: [],
  group: undefined,
  location: undefined,
  periodStart: undefined,
  periodEnd: undefined,
  soil: undefined,
  triggerRequest: undefined,
};

export const meteorologyAgroWBSequentialDVSlice = createSlice({
  name: 'meteorologyAgroWBSequentialDV',
  initialState,
  reducers: {
    setChart: (state, action: PayloadAction<number[]>) => {
      state.selectedChartVariables = action.payload;
    },
    setGroup: (state, action: PayloadAction<number | undefined>) => {
      state.group = action.payload;
    },
    setLocation: (state, action: PayloadAction<number | undefined>) => {
      state.location = action.payload;
    },
    setPeriodStart: (state, action: PayloadAction<string | undefined>) => {
      state.periodStart = action.payload;
    },
    setPeriodEnd: (state, action: PayloadAction<string | undefined>) => {
      state.periodEnd = action.payload;
    },
    setSoil: (state, action: PayloadAction<number | undefined>) => {
      state.soil = action.payload;
    },
    setTriggerRequest: (state, action: PayloadAction<(() => void) | undefined>) => {
      state.triggerRequest = action.payload;
    },
    resetControlPanel: (state) => {
      // filtros
      state.group = undefined;
      state.location = undefined;
      state.periodStart = undefined;
      state.periodEnd = undefined;
      state.soil = undefined;

      // gráficos
      state.selectedChartVariables = [];
      state.triggerRequest = undefined;
    },
  },
});

export const selectMeteorologyAgroWBSequentialDVSelectedChartVariables = (state: any) => (
  state.meteorologyAgroWBSequentialDV.selectedChartVariables
);

export const selectMeteorologyAgroWBSequentialDVGroup = (state: any) => (
  state.meteorologyAgroWBSequentialDV.group
);

export const selectMeteorologyAgroWBSequentialDVLocation = (state: any) => (
  state.meteorologyAgroWBSequentialDV.location
);

export const selectMeteorologyAgroWBSequentialDVPeriodStart = (state: any) => (
  state.meteorologyAgroWBSequentialDV.periodStart
);

export const selectMeteorologyAgroWBSequentialDVPeriodEnd = (state: any) => (
  state.meteorologyAgroWBSequentialDV.periodEnd
);

export const selectMeteorologyAgroWBSequentialDVSoil = (state: any) => (
  state.meteorologyAgroWBSequentialDV.soil
);

export const selectMeteorologyAgroWBSequentialDVTriggerRequest = (state: any) => (
  state.meteorologyAgroWBSequentialDV.triggerRequest
);

export const {
  setChart,
  setGroup,
  setLocation,
  setPeriodStart,
  setPeriodEnd,
  setSoil,
  setTriggerRequest,
  resetControlPanel,
} = meteorologyAgroWBSequentialDVSlice.actions;

export default meteorologyAgroWBSequentialDVSlice.reducer;
